export default "__VITE_ASSET__anhzSUMJ__"